import { Injectable } from '@angular/core';

import Highcharts from 'highcharts';

import moment from 'moment-timezone';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { SemantriaPreferences } from '../providers/bridge-api/preferences.service';

@EnableClassTelemetry()
@Injectable()
export class TimezoneService {
  private _timezone: string;
  private _timezoneOffset: string;
  readonly DEFAULT_TIMEZONE = 'America/New_York';

  constructor(private preferences: SemantriaPreferences) {
    this.preferences.subscribePreferences((timezone) => (this.timezone = timezone));
    this.timezone = this.DEFAULT_TIMEZONE;
  }

  set timezone(timezone) {
    this._timezone = timezone;
    this._timezoneOffset = this.calculateOffset(timezone);
    Highcharts.setOptions({ time: { timezone: this._timezone } });
  }

  public calculateOffset(timezone): string {
    const offsetMinutes: number = moment().tz(timezone).utcOffset();
    const hours = Math.floor(Math.abs(offsetMinutes) / 60);
    const minutes = Math.floor(Math.abs(offsetMinutes) % 60);
    let offset = ('' + hours).padStart(2, '0') + ':' + ('' + minutes).padStart(2, '0');
    if (offsetMinutes < 0) {
      offset = '-' + offset;
    } else {
      offset = '+' + offset;
    }
    return offset;
  }

  get timezone() {
    return this._timezone;
  }

  get timezoneOffset() {
    return this._timezoneOffset;
  }

  get defaultTimezone() {
    return this.DEFAULT_TIMEZONE;
  }

  now(): moment.Moment {
    return moment.utc().tz(this.timezone);
  }

  convertDate(
    date: string | Date | moment.Moment,
    formatFilterString: string = 'YYYY-MM-DD'
  ): moment.Moment {
    if (formatFilterString) {
      const m = moment(date);
      date = m.format(formatFilterString);
    }
    return moment.tz(date, this.timezone);
  }

  padToStart(date: Date, unit: moment.unitOfTime.StartOf = 'day') {
    return moment(date).startOf(unit).tz(this.timezone, true);
  }

  padToEnd(date: Date, unit: moment.unitOfTime.StartOf = 'day') {
    return moment(date).endOf(unit).tz(this.timezone, true);
  }
}
